import AppRoutes from './app/router/routes'

export default function App() {
  return <AppRoutes />
}
